import Button from './_button.js'
import FlexPane from './_flex-pane.js'
import Timer from './_timer.js'
import Text from './_text.js'
import DateTime from './_date-time.js'
import Image from './_image.js'

export default {
  name: 'EventTimingStatus',
  values: {
    container: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            minHeight: '16px',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '4px',
          },
        },
      },
    },
    dateTimeContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        separator: {
          style: {
            size: '1px',
            margin: '2px 0',
          },
        },
        style: {
          flexGrow: 0,
        },
      },
    },
    inPlayTime: {
      configSet: Timer,
      configValues: {},
    },
    liveText: {
      configSet: Text,
      configValues: {},
    },
    upcomingText: {
      configSet: Text,
      configValues: {},
    },
    timeFormatter: {
      configSet: DateTime,
      configValues: {},
    },
    dateFormatter: {
      configSet: DateTime,
      configValues: {
        showTodayAndTomorrowLabels: true,
      },
    },
    splitDateTime: false,
    showStreamIcon: true,
    streamingIcon: {
      configSet: Image,
      configValues: {
        src: 'streaming',
        style: {
          minWidth: '12px',
          minHeight: '12px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
